export default __webpack_public_path__ + "static/media/magenta-icon.d2fedcfd.svg";